import MyInfo from './MyInfo';

export default MyInfo;
